export default __webpack_public_path__ + "static/media/RegulatorsImg.5ad4f63d.jpg";